// chatra.js (module)
function loadChatraScript() {
	// Taal instellen o.b.v. <html lang="...">
	window.ChatraSetup = {
		language: document.documentElement.lang || "en",
	};

	// Standaard snippet
	(function (d, w, c) {
		w.ChatraID = "wQNPpAQH2umKHHDwm";

		var s = d.createElement("script");
		w[c] =
			w[c] ||
			function () {
				(w[c].q = w[c].q || []).push(arguments);
			};
		s.async = true;
		s.src = "https://call.chatra.io/chatra.js";
		if (d.head) d.head.appendChild(s);
	})(document, window, "Chatra");
}

export function initChatra() {
	// Laad Chatra pas bij eerste user interactie of na 10 seconden
	let chatraLoaded = false;

	function lazyLoad() {
		if (chatraLoaded) return;
		chatraLoaded = true;
		loadChatraScript();

		// Cleanup listeners
		window.removeEventListener("scroll", lazyLoad);
		window.removeEventListener("mousemove", lazyLoad);
		window.removeEventListener("touchstart", lazyLoad);
		window.removeEventListener("click", lazyLoad);
	}

	// Laad bij eerste user actie
	window.addEventListener("scroll", lazyLoad, { once: true, passive: true });
	window.addEventListener("mousemove", lazyLoad, { once: true, passive: true });
	window.addEventListener("touchstart", lazyLoad, {
		once: true,
		passive: true,
	});
	window.addEventListener("click", lazyLoad, { once: true, passive: true });

	// Fallback: laad sowieso na 10 seconden als er geen interactie is
	setTimeout(lazyLoad, 10000);
}
